import { GET } from "../adapters/xhr";

export default function (name, id) {
    return (dispatch) => {

        const url = "api/Vessel/DuplicateVesselCheck";
        const params = {
            name: name,
            id
        };

        GET(url, params)
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "VESSEL_NAME_IN_USE",
                        data: response.data.isDuplicate
                    });
                    dispatch({
                        type: "VESSEL_NAME_IN_USE_DUPLICATE_TYPE",
                        data: response.data.duplicateTypeId
                    });
                    dispatch({
                        type: "DUPLICATE_VESSEL_MMSI_NUMBERS",
                        data: response.data.mmsiNumbers
                    });
                    if (response.data.isDuplicate) {
                        switch (response.data.duplicateTypeId) {
                            case 1:
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE1_MODAL",
                                    data: true
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE2_MODAL",
                                    data: false
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE3_MODAL",
                                    data: false
                                });
                                break;
                            case 2:
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE1_MODAL",
                                    data: false
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE2_MODAL",
                                    data: true
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE3_MODAL",
                                    data: false
                                });
                                break;
                            case 3:
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE1_MODAL",
                                    data: false
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE2_MODAL",
                                    data: false
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE3_MODAL",
                                    data: true
                                });
                                break;
                            default:
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE1_MODAL",
                                    data: false
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE2_MODAL",
                                    data: false
                                });
                                dispatch({
                                    type: "SHOW_DUPLICATE_VESSEL_TYPE3_MODAL",
                                    data: false
                                });
                                break;
                        }
                    }
                }
            }).catch(function (response) {
            });
    };
}
